import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { ToastContainer, toast } from "react-toastify";
import { BsFillSuitHeartFill, BsShareFill } from "react-icons/bs";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import Searchbar from "./Shearchbar";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Manubar from "./Manubar";
import "./m.css";
import "./loader.css";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import DOMPurify from "dompurify";

const cleanHtml = (html) =>
  DOMPurify.sanitize(html, {
    FORBID_ATTR: ["style", "class"],
  });
const Single_products = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [slideIndex, setSlideIndex] = useState(0);
  const [images, setImages] = useState([]);
  const [productDetails, setProductDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [addingToCart, setAddingToCart] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Buy");
  const [selectedLease, setSelectedLease] = useState(null);
  const productsDetails = id;
  const _id = secureLocalStorage.getItem("n_id");
  const [showHowToWear, setShowHowToWear] = useState(false);

  const plusSlides = (n) => {
    if (productDetails?.product_image?.length > 0) {
      const newIndex = (slideIndex + n + images.length) % images.length;
      setSlideIndex(newIndex);
    }
  };

  const currentSlide = (n) => {
    setSlideIndex(n);
  };

  const fetchProductDetails = useCallback(async () => {
    if (!productsDetails) return;

    const controller = new AbortController();
    try {
      setLoading(true);
      const payload = {
        user_id: _id || "",
        product_id: productsDetails,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/product_details`,
        payload,
        {
          signal: controller.signal,
        },
      );

      if (res?.data?.result === "true") {
        console.log(res);
        setLoading(false);
        setImages(res?.data?.data?.product_image || []);
        setProductDetails(res.data.data);
        if (res?.data?.data?.lease_array?.length > 0) {
          setSelectedLease(res.data.data?.lease_array[0]);
        }
      }
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.error("Error fetching product:", error);
      }
    } finally {
      setLoading(false);
    }

    return () => controller.abort();
  }, [productsDetails, _id]);

  useEffect(() => {
    fetchProductDetails();
  }, [fetchProductDetails]);

  const addToCart = async () => {
    if (!_id) {
      toast.error("Please login to add items to cart");
      return;
    }

    if (addingToCart) return;

    if (selectedOption === "Lease" && !selectedLease) {
      toast.error("Please select a lease option");
      return;
    }

    try {
      setAddingToCart(true);

      let data = {};
      if (selectedOption === "Buy") {
        data = {
          user_id: _id,
          product_id: productDetails?._id,
          available_status: "Buy",
          no_of_product: 1,
          price: productDetails?.sale_price?.replace(/,/g, ""),
          total_price: productDetails?.sale_price.replace(/,/g, ""),
          category_id: productDetails?.category_id,
          sub_category_id: productDetails?.sub_category_id,
        };
      } else if (selectedOption === "Lease") {
        data = {
          user_id: _id,
          product_id: productDetails?._id,
          available_status: "Lease",
          no_of_product: 1,
          price: productDetails?.sale_price?.replace(/,/g, ""),
          total_price: productDetails?.sale_price?.replace(/,/g, ""),
          category_id: productDetails?.category_id,
          sub_category_id: productDetails?.sub_category_id,
        };
      }

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/add_to_cart`,
        data,
      );

      if (res.data.result) {
        toast.success("✅ " + res.data.msg);
        if (res.data.data?._id) {
          secureLocalStorage.setItem("n_cartlist_id", res.data.data._id);
        }
        fetchProductDetails();
      }
    } catch (error) {
      console.error("Add to cart error:", error);
    } finally {
      setAddingToCart(false);
    }
  };

  const addToFavorites = async (productId, favStatus) => {
    try {
      const items = {
        user_id: _id,
        product_id: productId,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/add_favourite_product`,
        items,
      );

      if (res.data.result) {
        if (favStatus === "1") {
          toast.success("💔 Product removed from favourites.");
        } else {
          toast.success("❤️ Product added to favourites successfully.");
        }
        fetchProductDetails();
      }
    } catch (error) {
      console.error("Favorite error:", error);
      fetchProductDetails();
    }
  };

  const renderSpecifications = () => {
    const specs = [
      { label: "Certification", value: productDetails?.certification },
      { label: "Colour", value: productDetails?.colour },
      { label: "Specific Gravity", value: productDetails?.specific_gravity },
      { label: "Treatment", value: productDetails?.treatment },
      { label: "Exact Dimensions", value: productDetails?.exact_dimensions },
      { label: "Refractive Index", value: productDetails?.refractive_index },
      { label: "Cut", value: productDetails?.cut },
      { label: "Shape", value: productDetails?.shape },
      { label: "Weight", value: productDetails?.weight },
      { label: "Origin", value: productDetails?.origin },
      { label: "Return Policy", value: productDetails?.return_policy },
    ];

    return (
      <div className="specifications mt-4">
        <div className=" mb-3 d-flex align-items-center justify-content-between">
          <h4 className="mb-3" style={{ color: "#160015" }}>
            Product Details
          </h4>

          <Button
            variant="outlined"
            startIcon={<InfoOutlineIcon />}
            sx={{
              backgroundColor: "#160015",
              color: "#fff",
              borderRadius: "20px",
            }}
            onClick={() => setShowHowToWear(true)}
          >
            {" "}
            How to wear
          </Button>
        </div>
        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <tbody>
              {specs.map(
                (spec, index) =>
                  spec.value && (
                    <tr key={index}>
                      <td
                        className="fw-semibold"
                        style={{ width: "40%", color: "#160015" }}
                      >
                        {spec.label}
                      </td>
                      <td style={{ color: "#160015" }}>{spec.value}</td>
                    </tr>
                  ),
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="min-vh-100 d-flex justify-content-center align-items-center">
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <>
      <div className="single-product-page" style={{ paddingBottom: "60px" }}>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />

        {/* Header Section */}
        <div className="modal fade offcanvas-modal" id="exampleModal">
          <div className="modal-dialog offcanvas-dialog">
            <div className="modal-content">
              <Manubar />
            </div>
          </div>
        </div>

        <header>
          <Searchbar />
          <Navbar />
        </header>

        {/* Breadcrumb */}
        <nav
          className="breadcrumb-section py-3"
          style={{ backgroundColor: "#160015" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <ol className="breadcrumb m-0 p-0 align-items-center">
                  <li className="breadcrumb-item">
                    <Link
                      to="/"
                      className="text-decoration-none"
                      style={{ color: "#fee894" }}
                    >
                      Home
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link
                      to="/shop"
                      className="text-decoration-none"
                      style={{ color: "#fee894" }}
                    >
                      Products
                    </Link>
                  </li>
                  <li
                    className="breadcrumb-item active fw-semibold"
                    style={{ color: "#fee894" }}
                  >
                    {productDetails?.product_title}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </nav>

        {loading ? (
          <div
            className="text-center py-5"
            style={{ backgroundColor: "#fef9e7" }}
          >
            <div className="loader"></div>
            <p className="mt-3" style={{ color: "#160015" }}>
              Loading product details...
            </p>
          </div>
        ) : productDetails ? (
          <section className="py-5">
            <div className="container">
              <div className="row g-5">
                {/* Product Images */}
                <div className="col-lg-5">
                  <div className="product-gallery" style={{ height: "100%" }}>
                    <div
                      className="main-image position-relative rounded-3 p-3"
                      style={{
                        height: "100%",
                        backgroundColor: "#fff",
                        border: "2px solid #160015",
                      }}
                    >
                      <div className="image-container text-center">
                        {images.length > 0 ? (
                          <img
                            className="img-fluid rounded-2"
                            src={`${process.env.REACT_APP_API}uploads/${images[slideIndex]}`}
                            alt={productDetails?.product_title}
                            style={{
                              height: "290px",
                              width: "auto",
                              objectFit: "contain",
                            }}
                          />
                        ) : (
                          <div
                            className="d-flex align-items-center justify-content-center"
                            style={{ height: "290px" }}
                          >
                            <div className="text-muted">No image available</div>
                          </div>
                        )}
                      </div>

                      {images.length > 1 && (
                        <>
                          <button
                            className="btn position-absolute top-50 start-0 translate-middle-y rounded-circle"
                            onClick={() => plusSlides(-1)}
                            style={{
                              width: "45px",
                              height: "45px",
                              padding: "0px",
                              backgroundColor: "#1e40af",
                              color: "#fff",
                            }}
                          >
                            <HiChevronLeft size={20} />
                          </button>
                          <button
                            className="btn position-absolute top-50 end-0 translate-middle-y rounded-circle"
                            onClick={() => plusSlides(1)}
                            style={{
                              width: "45px",
                              height: "45px",
                              padding: "0px",
                              backgroundColor: "#1e40af",
                              color: "#fff",
                            }}
                          >
                            <HiChevronRight size={20} />
                          </button>

                          <div className="image-counter position-absolute bottom-0 start-50 translate-middle-x mb-2">
                            <span
                              className="badge px-3 py-2"
                              style={{
                                backgroundColor: "#160015",
                                color: "#fee894",
                                border: "1px solid #fee894",
                              }}
                            >
                              {slideIndex + 1} / {images.length}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Product Info */}
                <div className="col-lg-7">
                  <div className="product-info">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "15px",
                      }}
                    >
                      <h1
                        className="h2 fw-bold mb-0"
                        style={{ flex: 1, color: "#160015" }}
                      >
                        {productDetails?.product_title}
                      </h1>

                      <div className="action-buttons d-flex gap-3 mb-4">
                        <div className="wishlist-btn">
                          {_id ? (
                            productDetails?.favourite_status === "1" ? (
                              <button
                                className="btn rounded-circle p-3"
                                onClick={() =>
                                  addToFavorites(
                                    productDetails?._id,
                                    productDetails?.favourite_status,
                                  )
                                }
                                title="Remove from wishlist"
                                style={{
                                  border: "2px solid #160015",
                                  backgroundColor: "#fee894",
                                  color: "#160015",
                                }}
                              >
                                <BsFillSuitHeartFill size={20} />
                              </button>
                            ) : (
                              <button
                                className="btn rounded-circle p-3"
                                onClick={() =>
                                  addToFavorites(
                                    productDetails?._id,
                                    productDetails?.favourite_status,
                                  )
                                }
                                title="Add to wishlist"
                                style={{
                                  border: "2px solid #160015",
                                  backgroundColor: "#fff",
                                  color: "#160015",
                                }}
                              >
                                <BsFillSuitHeartFill size={20} />
                              </button>
                            )
                          ) : (
                            <Link
                              to="/login"
                              className="btn rounded-circle p-3 text-decoration-none"
                              title="Login to add to wishlist"
                              style={{
                                border: "2px solid #160015",
                                backgroundColor: "#fff",
                                color: "#160015",
                              }}
                            >
                              <BsFillSuitHeartFill size={20} />
                            </Link>
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      className="category-text mb-3"
                      style={{ color: "#160015" }}
                    >
                      <span className="">
                        <strong>{productDetails?.origin}</strong>{" "}
                      </span>
                    </div>

                    <div
                      className="product-price-wrapp-lg"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginTop: "6px",
                      }}
                    >
                      <span
                        className="product-price-lg"
                        style={{
                          fontSize: "15px",
                          fontWeight: "500",
                          color: "#160015",
                        }}
                      >
                        Buy Price:
                      </span>

                      <span
                        className="product-price-on-sale-lg"
                        style={{
                          fontSize: "20px",
                          fontWeight: "700",
                          color: "#160015",
                        }}
                      >
                        ₹{productDetails?.sale_price?.toLocaleString()}
                      </span>
                    </div>

                    <p className="text-muted m-0 text-start">OR</p>

                    <div
                      className="product-price-wrapp-lg"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginTop: "6px",
                      }}
                    >
                      <span
                        className="product-price-lg"
                        style={{
                          fontSize: "15px",
                          fontWeight: "500",
                          color: "#160015",
                        }}
                      >
                        Lease starting from:
                      </span>

                      <span
                        className="product-price-on-sale-lg"
                        style={{
                          fontSize: "20px",
                          fontWeight: "700",
                          color: "#160015",
                        }}
                      >
                        ₹
                        {productDetails?.lease_array?.[0]?.lease_price
                          ? productDetails.lease_array[0].lease_price.toLocaleString()
                          : "0"}
                      </span>
                    </div>

                    <div
                      className="product-price-wrapp-lg"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginTop: "6px",
                      }}
                    >
                      <span
                        className="product-price-lg"
                        style={{
                          fontSize: "15px",
                          fontWeight: "500",
                          color: "#160015",
                        }}
                      >
                        Security Deposit:
                      </span>

                      <span
                        className="product-price-on-sale-lg"
                        style={{
                          fontSize: "20px",
                          fontWeight: "700",
                          color: "#160015",
                        }}
                      >
                        ₹{productDetails?.rent_price?.toLocaleString()}
                      </span>
                    </div>

                    {/* Description */}
                    <div className="description-section mb-4">
                      <h5
                        className="fw-semibold mb-2"
                        style={{ color: "#160015" }}
                      >
                        Description
                      </h5>
                      <p
                        className="mb-0"
                        style={{ textAlign: "justify", color: "#160015" }}
                      >
                        {productDetails?.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="container">
              {/* Product Specifications */}
              {renderSpecifications()}

              {/* Option Selection */}
              <div
                className="option-selection mb-3"
                style={{
                  border: "2px solid #160015",
                  borderRadius: "8px",
                  padding: "12px 14px",
                  backgroundColor: "#fff",
                }}
              >
                {/* BUY OPTION */}
                {productDetails?.available_status?.includes("Buy") && (
                  <div
                    className="form-check mb-2"
                    style={{
                      padding: "8px 10px",
                      borderRadius: "6px",
                      backgroundColor:
                        selectedOption === "Buy" ? "#fee894" : "#fff",
                      border:
                        selectedOption === "Buy"
                          ? "2px solid #160015"
                          : "1px solid #ccc",
                    }}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="purchaseOption"
                      id="radioBuy"
                      checked={selectedOption === "Buy"}
                      onChange={() => {
                        setSelectedOption("Buy");
                        setSelectedLease(null);
                      }}
                      style={{ accentColor: "#160015" }}
                    />
                    <label
                      className="form-check-label small"
                      htmlFor="radioBuy"
                      style={{
                        marginLeft: "6px",
                        cursor: "pointer",
                        color: "#160015",
                        fontWeight: selectedOption === "Buy" ? "600" : "400",
                      }}
                    >
                      I want to buy this product at{" "}
                      <strong>₹{productDetails?.sale_price}</strong>
                    </label>
                  </div>
                )}

                {/* LEASE OPTION */}
                {productDetails?.available_status?.includes("Lease") && (
                  <div
                    className="form-check"
                    style={{
                      padding: "8px 10px",
                      borderRadius: "6px",
                      backgroundColor:
                        selectedOption === "Lease" ? "#fee894" : "#fff",
                      border:
                        selectedOption === "Lease"
                          ? "2px solid #160015"
                          : "1px solid #ccc",
                    }}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="purchaseOption"
                      id="radioLease"
                      checked={selectedOption === "Lease"}
                      onChange={() => {
                        setSelectedOption("Lease");
                        if (
                          !selectedLease &&
                          productDetails?.lease_array?.length > 0
                        ) {
                          setSelectedLease(productDetails.lease_array[0]);
                        }
                      }}
                      style={{ accentColor: "#160015" }}
                    />
                    <label
                      className="form-check-label small"
                      htmlFor="radioLease"
                      style={{
                        marginLeft: "6px",
                        cursor: "pointer",
                        color: "#160015",
                        fontWeight: selectedOption === "Lease" ? "600" : "400",
                      }}
                    >
                      I want to lease this product
                    </label>
                  </div>
                )}
              </div>

              {/* Lease Options */}
              {selectedOption === "Lease" &&
                productDetails?.lease_array?.length > 0 && (
                  <div className="lease-options mb-4">
                    <label
                      className="form-label fw-semibold mb-2"
                      style={{ color: "#160015" }}
                    >
                      Lease Refund:
                    </label>
                    <div className="row g-2">
                      {productDetails.lease_array.map((lease, index) => (
                        <div className="col-12" key={lease.lease_id}>
                          <div
                            className={`card ${selectedLease?.lease_id === lease.lease_id ? "border-2" : "border-1"}`}
                            style={{
                              cursor: "pointer",
                              borderColor:
                                selectedLease?.lease_id === lease.lease_id
                                  ? "#160015"
                                  : "#ddd",
                              backgroundColor: "#fff",
                            }}
                            onClick={() => setSelectedLease(lease)}
                          >
                            <div className="card-body py-2">
                              <div className="row align-items-center">
                                <div className="col-md-3">
                                  <h6
                                    className="mb-0"
                                    style={{ color: "#160015" }}
                                  >
                                    {lease.days}
                                  </h6>
                                </div>
                                <div className="col-md-9">
                                  <div className="row text-center">
                                    <div className="col">
                                      <small className="text-muted d-block">
                                        Deposit
                                      </small>
                                      <div
                                        className="fw-semibold"
                                        style={{ color: "#160015" }}
                                      >
                                        ₹{lease.deposit_price?.toLocaleString()}
                                      </div>
                                    </div>
                                    <div className="col">
                                      <small className="text-muted d-block">
                                        Lease Price
                                      </small>
                                      <div
                                        className="fw-bold"
                                        style={{ color: "#160015" }}
                                      >
                                        ₹{lease.lease_price?.toLocaleString()}
                                      </div>
                                    </div>
                                    <div className="col">
                                      <small className="text-muted d-block">
                                        Refund
                                      </small>
                                      <div
                                        className="fw-semibold"
                                        style={{ color: "#160015" }}
                                      >
                                        ₹{lease.refund_price?.toLocaleString()}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="form-check mt-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="checkDefault"
                        style={{ accentColor: "#160015" }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="checkDefault"
                        style={{ color: "#160015" }}
                      >
                        I accept Lease{" "}
                        <Link
                          style={{
                            color: "#160015",
                            textDecoration: "underline",
                          }}
                          to="/termsAndCondition"
                        >
                          terms
                        </Link>
                      </label>
                    </div>
                  </div>
                )}

              {/* Quantity Selection */}
              <div className="add-to-cart-section mb-4">
                <div className="row g-3 align-items-center">
                  <div className="col">
                    {_id ? (
                      productDetails?.cart_status === "1" ? (
                        <button
                          onClick={() => navigate("/cardlist")}
                          className="btn btn-lg w-100 py-3"
                          style={{
                            backgroundColor: "#fee894",
                            color: "#160015",
                            border: "2px solid #160015",
                            fontWeight: "600",
                          }}
                        >
                          Already in Cart (Go to Cart)
                        </button>
                      ) : (
                        <button
                          className="btn btn-lg w-100 py-3"
                          onClick={addToCart}
                          disabled={
                            addingToCart ||
                            (selectedOption === "Lease" && !selectedLease) ||
                            productDetails?.quantity <= 0
                          }
                          style={{
                            backgroundColor: addingToCart ? "#ccc" : "#160015",
                            color: addingToCart ? "#666" : "#fee894",
                            border: addingToCart
                              ? "2px solid #ccc"
                              : "2px solid #160015",
                            fontWeight: "600",
                            opacity: addingToCart ? 0.7 : 1,
                          }}
                        >
                          {addingToCart ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2"></span>
                              Adding...
                            </>
                          ) : selectedOption === "Buy" ? (
                            "Add to Cart"
                          ) : (
                            "Lease Now"
                          )}
                        </button>
                      )
                    ) : (
                      <Link
                        to="/login"
                        className="btn btn-lg w-100 py-3 text-decoration-none"
                        style={{
                          backgroundColor: "#160015",
                          color: "#fee894",
                          border: "2px solid #160015",
                          fontWeight: "600",
                        }}
                      >
                        Login to{" "}
                        {selectedOption === "Buy" ? "Add to Cart" : "Lease"}
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : (
          <div
            className="text-center py-5"
            style={{ backgroundColor: "#fef9e7" }}
          >
            <p className="mt-3" style={{ color: "#160015" }}>
              Product not found.
            </p>
          </div>
        )}
      </div>

      <Dialog
        open={showHowToWear}
        keepMounted
        onClose={() => setShowHowToWear(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"How To Wear"}</DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            dangerouslySetInnerHTML={{
              __html: cleanHtml(productDetails?.category_desription || ""),
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowHowToWear(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Single_products;
